import React from "react";
import { v4 as guid } from "uuid";

/**
 *
 * @param {*} props
 * checked
 * children
 * onChange
 * value
 * @returns
 */
export default function InputRadio(props) {
    const [id, setId] = React.useState(guid());

    function onChange() {
        props.onChange(props.value, !props.checked);
    }

    const CLInputRadio = ["input-radio"];
    props.checked && CLInputRadio.push("checked");

    return (
        <label tabIndex={0} htmlFor={id} className={CLInputRadio.join(" ")}>
            <div className="input-radio-wrap">
                <input id={id} type="radio" onChange={onChange} checked={props.checked} />
                <div className="input-radio-inner"></div>
            </div>

            {props.children && <div>{props.children}</div>}
        </label>
    );
}
